// models
import type { ReqSafetyDetail, ReqSafetyList } from '../model/safety.model';

/**
 * Safety 관련 Query Keys
 *
 * @description
 * 안전 교육 관련 query-key들을 관리합니다.
 */
export const safetyKeys = {
  /** ALL */
  SAFETY_ALL: ['safety'],

  /** 안전 교육 페이지 */
  GET_SAFETY_TRAININGS: (query: ReqSafetyList) => [
    'safety',
    'getSafetyTrainings',
    JSON.stringify(query)
  ],

  /** 안전 교육 상세 조회 */
  GET_SAFETY_TRAINING_DETAIL: (data: ReqSafetyDetail) => [
    'safety',
    'getSafetyTrainingDetail',
    JSON.stringify(data)
  ]
};
